// Infinite scroll for collection pages
// Exposes window.initInfiniteScroll() so it can be re-initialized after AJAX swaps
// Self-contained: injects its own CSS + UI markup

(function () {
  let currentObserver = null;
  let stylesInjected = false;

  function injectStyles() {
    if (stylesInjected) return;
    var style = document.createElement('style');
    style.textContent = '@keyframes infSpin{to{transform:rotate(360deg)}}';
    document.head.appendChild(style);
    stylesInjected = true;
  }

  function getTotal(trigger) {
    // 1. Try data-total on the trigger element
    var attr = trigger.getAttribute('data-total');
    if (attr && parseInt(attr, 10) > 0) return attr;

    // 2. Try reading from Shopify's product count text (e.g. "123 products")
    var countEl = document.getElementById('ProductCountDesktop');
    if (countEl) {
      var match = countEl.textContent.match(/(\d+)/);
      if (match) return match[1];
    }

    // 3. Try the mobile product count
    var countMobile = document.getElementById('ProductCount');
    if (countMobile) {
      var matchM = countMobile.textContent.match(/(\d+)/);
      if (matchM) return matchM[1];
    }

    return '0';
  }

  function buildUI(container, total) {
    // Remove any previous status block so re-init after tab swap starts fresh
    var existing = container.querySelector('.infinite-scroll-status');
    if (existing) existing.remove();

    var trigger = container.querySelector('.infinite-scroll-trigger');
    if (!trigger) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'infinite-scroll-status';
    wrapper.style.cssText = 'text-align:center;padding:24px 0;';

    wrapper.innerHTML =
      '<p class="infinite-scroll-count" style="font-size:16px;letter-spacing:0.01em;color:#333;margin:0 0 16px;">' +
        'You\'ve viewed <span id="viewed-count">0</span> of ' + total + ' results' +
      '</p>' +
      '<div class="infinite-scroll-spinner" style="display:none;">' +
        '<div style="background:#000;border-radius:9999px;width:280px;height:56px;margin:0 auto;display:flex;align-items:center;justify-content:center;">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="animation:infSpin .8s linear infinite;">' +
            '<circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.25)" stroke-width="2.5"/>' +
            '<path d="M12 2a10 10 0 0 1 10 10" stroke="#fff" stroke-width="2.5" stroke-linecap="round"/>' +
          '</svg>' +
        '</div>' +
      '</div>';

    trigger.parentNode.insertBefore(wrapper, trigger);
    wrapper.appendChild(trigger);
  }

  function updateCount(grid) {
    var viewedEl = document.getElementById('viewed-count');
    if (viewedEl) {
      viewedEl.textContent = grid.querySelectorAll(':scope > li').length;
    }
  }

  function init() {
    // Clean up any previous observer
    if (currentObserver) {
      currentObserver.disconnect();
      currentObserver = null;
    }

    var trigger = document.querySelector('.infinite-scroll-trigger');
    if (!trigger) return;

    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var total = getTotal(trigger);

    injectStyles();
    buildUI(trigger.parentNode, total);

    // Re-query trigger since buildUI moved it inside the wrapper
    trigger = document.querySelector('.infinite-scroll-trigger');
    if (!trigger) return;

    var spinner = document.querySelector('.infinite-scroll-spinner');
    updateCount(grid);

    var loading = false;

    currentObserver = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (!entry.isIntersecting || loading) return;

        var nextUrl = trigger.getAttribute('data-next-url');
        if (!nextUrl) return;

        loading = true;
        if (spinner) spinner.style.display = '';

        fetch(nextUrl)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newItems = doc.querySelectorAll('#product-grid > li');
            newItems.forEach(function (item) { grid.appendChild(item); });

            updateCount(grid);

            var newTrigger = doc.querySelector('.infinite-scroll-trigger');
            if (newTrigger && newTrigger.getAttribute('data-next-url')) {
              trigger.setAttribute('data-next-url', newTrigger.getAttribute('data-next-url'));
            } else {
              trigger.remove();
              if (spinner) spinner.remove();
            }

            if (spinner) spinner.style.display = 'none';
            loading = false;
          })
          .catch(function () {
            if (spinner) spinner.style.display = 'none';
            loading = false;
          });
      },
      { rootMargin: '0px 0px 400px 0px' }
    );

    currentObserver.observe(trigger);
  }

  window.initInfiniteScroll = init;
  init();
})();